<template>
  <div class="collapse-control" :class="'task-listing-collapsible-'+index" @click="expanded=!expanded; toggleStatusView('.task-listing-collapsible-'+index)" v-b-toggle="'task-listing-collapse-'+index">
    <div
      class="task-exp"
    >
      <!-- <DeliverableTypeIcon :deliverableTypeId="deliverable.deliverable_template_id" /> -->
      <span v-if="!expanded">
        <span v-if="deliverable.tasks.length == 1">{{deliverable.tasks.length}}<br> TASK<br></span>
        <span v-else>{{deliverable.tasks.length}}<br> TASKS</span>
        <span class="icon">
          <img src="@/csmworkflow/img/chevron-down.svg" />
        </span>
      </span>
      <span v-else>
        <span>CLOSE</span>
        <span class="icon close-collase">
          <img src="@/csmworkflow/img/chevron-up.svg" />
        </span>
      </span>
    </div>
    <div class="task-exp exp-mobile">
      <span v-if="!expanded">
        <span class="icon">
          <img src="@/csmworkflow/img/chevron-down.svg" />
        </span>
      </span>
      <span v-else>
        <span>
          <span class="icon close-collase">
            <img src="@/csmworkflow/img/chevron-up.svg" />
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import DeliverableTypeIcon from './DeliverableTypeIcon';
export default {
  props: ["deliverable", "expandAll", "index"],
  components: {
    DeliverableTypeIcon
  },
  data() {
    return {
      expanded: !this.isMobile()
    };
  },
  methods: {
    toggleStatusView(elem) {
      if($(elem).hasClass('collapsed')) {
        $('.deliv-'+this.index).find('.deliverable-status-overview').hide();
        $('.deliv-'+this.index).find('.deliverable-dates').css('padding-top', 0);
      } else {
        $('.deliv-'+this.index).find('.deliverable-status-overview').show();
        $('.deliv-'+this.index).find('.deliverable-dates').css('padding-top', '15px');
      }
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (id, state) => {
      if (id == ('task-listing-collapse-'+this.index)) {
        this.expanded = state;
      }
    })
  },
  watch: {
    expandAll: function(newVal, oldVal) {
      this.expanded = newVal;
    },
  }
};
</script>

<style>
</style>